import cn from 'classnames'
import * as React from 'react'
import { defineMessages, FormattedMessage } from 'react-intl'

import { screenBiggerThan } from '../../../../lib/screen-utils'

import Button from '../../../../components/button'
import CoverVideo from '../../../../components/cover-video'

import styles from './hero.module.scss'
import videoDesktop from './career-hero.mp4'
import videoMobile from './career-hero-mobile.mp4'
import posterDesktop from './career-hero-poster.jpg'
import posterMobile from './career-hero-poster-mobile.jpg'

const messages = defineMessages({
  button: {
    defaultMessage: 'Ja, jag vill bli en Dooer!',
    id: 'career.hero.button',
  },
  heading: {
    defaultMessage: 'Nu har du chansen att bli en del av vårt team',
    id: 'career.hero.heading',
  },
  lede: {
    defaultMessage:
      'Är du sugen på på att utvecklas supersnabbt, förändra en hel bransch och uppleva en helt unik startupresa där ingenting är omöjligt. Bli en Dooer du också!',
    id: 'career.hero.lede',
  },
})

export default function Hero() {
  const [videoEnded, setVideoEnded] = React.useState(false)

  return (
    <div className={styles.root}>
      <div className={styles.outer}>
        <CoverVideo
          className={cn(styles.video, videoEnded && styles.videoFade)}
          loop={false}
          onEnded={() => setVideoEnded(true)}
          poster={screenBiggerThan('xs') ? posterDesktop : posterMobile}
          src={screenBiggerThan('xs') ? videoDesktop : videoMobile}
        />
        <div className={cn(styles.fade, videoEnded && styles.fadeVisible)} />
        <div className={cn(styles.inner, videoEnded && styles.innerVisible)}>
          <h1 className={styles.heading}>
            <FormattedMessage {...messages.heading} />
          </h1>
          <p className={styles.lede}>
            <FormattedMessage {...messages.lede} />
          </p>
          <Button className={styles.button} href="#jobs">
            <FormattedMessage {...messages.button} />
          </Button>
        </div>
      </div>
    </div>
  )
}
